import { ArrowBack } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import LOGO from "../../../assets/images/mtn.png";
import { store } from '../../../services/service';
import { RESET_PASSWORD } from '../../../Utils/constant';
import { HOME, isLoggedIn, NavigateToHome } from '../../../Utils/Utils';


export const ForgotPassword = () => {
  const navigate = useNavigate();

  const { register, handleSubmit } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);

  const submit = (data) => {
    setIsSubmit(true)
    store(`${RESET_PASSWORD}?username=${data.username}`, 'application/json', {}).then((res) => {
      if (res.status === 200) {
        setIsSubmit(null)
        toast.success('Mot de passe rénitialisé')
        navigate(`${HOME}/login`)
      }
    }).catch((err) => {
      setIsSubmit(false)
      toast.error(err?.response?.data?.donnee, { duration: 4000 })
    })
  }

  useEffect(() => {
    if (isLoggedIn()) {
      navigate(NavigateToHome())
    }
  }, [navigate])

  return (

    <div
      class="font-mtn bg-white  items-center justify-center"
    >

      <form onSubmit={handleSubmit(submit)} className="shadow font-mtn border rounded w-fit p-8 mx-auto mt-28">
        <Link to={`${HOME}/login`} className='text-sm underline gap-3'><ArrowBack fontSize='14' />Retour</Link>
        <div class="space-y-2 my-3">
          <div className="flex gap-x-2 ">
            <img alt="" src={LOGO} className="w-9 rounded-2xl" />

            <p className="my-auto font-bold text-xl">MTN Fibre</p>
          </div>

          <div class="flex flex-col space-y-2 mt-1">
            <h1 class="text-2xl font-semibold tracking-tight">Mot de passe oublié</h1>
            <p class="text-sm text-muted-foreground">
              Saisissez votre username ci-dessous et nous vous enverrons un mail<br />
              pour réinitialiser votre mot de passe.
            </p>
          </div>
          <div class="mt-3">
            <label className="text-sm font-medium">Username <span className="text-red-500">*</span></label>
            <div className='mt-2'>
              <input
                {...register('username', { required: true })}
                type="text"
                placeholder="Username"
                className="input input-bordered w-full h-10 text-sm "
              />
            </div>
          </div>

          {/* <div class="">
            <label className="text-sm font-medium">Nouveau mot de passe <span className="text-red-500">*</span></label>
            <div className='mt-2'>
              <input
                {...register('newPassword', { required: true })}
                type="password"
                placeholder="Nouveau mot de passe"
                className="input input-bordered w-full h-10 text-sm "
              />
            </div>
          </div>

          <div class="">
            <label className="text-sm font-medium">Confirmer le mot de passe <span className="text-red-500">*</span></label>
            <div className='mt-2'>
              <input
                {...register('passwordConfirm', { required: true })}
                type="password"
                placeholder="Confirmer mot de passe"
                className="input input-bordered w-full h-10 text-sm "
              />
            </div>
          </div> */}

          <button
            type="submit"
            disabled={isSubmit ? true : false}
            className={`${!isSubmit
              ? "text-slate-900 bg-amber-300"
              : "text-slate-800 bg-slate-200 "
              } w-full inline-flex items-center my-3 justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow hover:bg-slate-900 hover:text-white h-9 px-4 py-2`}

          >
            {isSubmit ? "Veuillez patientez... " : "Rénitialiser le mot de passe"}{" "}
            {isSubmit ? (
              <span className="loading loading-dots loading-xs"></span>
            ) : null}
          </button>
        </div>
      </form>
    </div>

  );
};